<template>
  <GcBaseLayout
    :title="title"
    :isXSmall="isXSmall"
    :isLarge="isLarge"
    :baseView="baseView"
    :key="pageKey"
    :backButtonEnable="backButtonRoute ? true : false"
    :backButtonFunction="backButtonFunction"
    :formsConfig="formsConfig"
    :tabs="[]"
    :selectedIndex="undefined"
    ref="gc-base-layout"
  >
    <slot> </slot>
    <template #headerContent>
      <GcHeaderContentDynamic
        :title="getScreenJson.title"
        :createModeIsEditMode="getHeaderScreenJson.title.createModeIsEditMode"
        :baseView="baseView"
        :primaryLabel="
          baseView.mode == 'create'
            ? 'Create Sales Order'
            : 'Sales Order # ' + baseView.id
        "
        :secondaryLabel="
          baseView.mode == 'review' ? model.CustomerName : undefined
        "
        v-if="loaded"
      />
    </template>

    <div v-if="loaded" class="sales-order-v5 css-v2 transaction-screen">
      <gc-header-form
        :headerOptions="getHeaderScreenJson"
        :data="loaded ? model : {}"
        :saveTransaction="saveTransaction"
        :backButtonRoute="backButtonRoute"
        ref="gc-header-form-component"
        :getHeaderToolbar="undefined"
        :setLoading="showLoading"
        v-show="!gridExpand"
      ></gc-header-form>

      <div class="gc-data-grid-so-v5 data-grid-details">
        <div
          class="left"
          v-show="baseView.mode != 'review'"
          style="padding-right: 10px; width: 20%"
        >
          <div class="gc-product-entry-form view-card responsive-paddings">
            <dx-form
              :ref="'dx-form-add-new-comp'"
              :items="addNewFormItems"
              labelLocation="left"
              :form-data.sync="addNewFormModel"
              :scrolling-enabled="true"
              :height="getGridHeight - 70"
              :show-colon-after-label="false"
              :show-required-mark="false"
              :show-validation-summary="false"
              :fromFrom="'so-v5'"
            />
            <div class="footer" style="text-align: end">
              <dx-button
                :text="'Add Item'"
                @click="addNewProductRecord"
                :accessKey="'add-new-item'"
                :disabled="!addNewFormModel.ValidCode"
              />
              <dx-button :text="'Clear'" @click="clearAddNewProductRecord" />
            </div>
          </div>
        </div>
        <div
          class="right gc-details-grid"
          v-bind:style="{
            width: baseView.mode != 'review' ? `80%` : '100%',
          }"
        >
          <dx-data-grid
            :data-source="productEntryLocalItems"
            :columns="getProductEntryColumns"
            :height="getGridHeight"
            :column-chooser="{ enabled: false }"
            :ref="'dx-data-grid-comp'"
            :key-expr="'ID'"
            :repaint-changes-only="true"
            :show-borders="true"
            :on-row-prepared="onRowPrepared"
            :two-way-binding-enabled="false"
            @editor-preparing="onEditorPreparing"
            :focusedRowEnabled="true"
            @toolbar-preparing="onToolbarPreparing($event)"
            :on-row-removed="onRowRemoved"
            @content-ready="onContentReady"
            @cell-dbl-click="cellDblClick"
          >
            <DxEditing :allow-deleting="baseView.mode != 'review'" />

            <DxKeyboardNavigation
              :edit-on-key-press="true"
              :enter-key-action="'startEdit'"
              :enter-key-direction="'none'"
              :enabled="true"
            />

            <DxPaging :page-size="200" :enabled="false" />

            <DxPager
              :showInfo="true"
              :showPageSizeSelector="false"
              :infoText="'({2} items)'"
              :visible="false"
              class="gc-pager"
              cssClass="gc-pages-2"
            />

            <template #menu-cell-template="{ data }">
              <DxDropDownButton
                :items="[
                  { menuText: 'Line Comment', data: data },
                  { menuText: 'Item History', data: data },
                ]"
                keyExpr="menuText"
                displayExpr="menuText"
                :drop-down-options="{ width: 250 }"
                class="gc-dropdown-icon-button"
                :id="data.data.ID"
                :icon="'overflow'"
                styling-mode="text"
                :show-arrow-icon="false"
                :onItemClick="onSoDetailsLineContextMenuItemClick"
                :disabled="!data.data.ItemCode"
              />
            </template>
          </dx-data-grid>
        </div>
      </div>

      <GcFooter v-if="showFooter">
        <template #leftContent>
          <div
            class="gc-grid-footer-item"
            v-for="item in footerLeftItems"
            :key="item.label"
          >
            <label class="gc-footer-label">{{ item.label }}</label>

            <label
              v-if="item.fieldType == 'custome-string'"
              class="gc-footer-value"
              >{{ item.value }}</label
            >
            <GcFooterItem
              :value="item.value"
              :format="item.format"
              :length="item.format == 'Decimal-16-4C' ? 8 : 6"
              v-else
            />
          </div>
        </template>
        <template #rightContent>
          <div
            class="gc-grid-footer-item"
            v-for="item in footerRightItems"
            :key="item.label"
          >
            <label class="gc-footer-label">{{ item.label }}</label>
            <GcFooterItem
              :value="item.value"
              :format="item.format"
              :length="item.format == 'Decimal-16-4C' ? 8 : 6"
            />
          </div>
        </template>
      </GcFooter>
    </div>

    <!-- Product Search Popup  -->
    <GcPopUpSearchForItem
      v-if="searchForItem && searchForItem.visible"
      :setVisible="searchForItem.visible"
      :callBack="searchForItem.popUpCallBack"
      :baseView="baseView"
      :setLoading="showLoading"
      :productListQuery="
        searchForItem.productListQuery
          ? searchForItem.productListQuery
          : undefined
      "
      :productListColumns="
        searchForItem.columns ? searchForItem.columns : undefined
      "
      :productListItems="
        searchForItem.productListItems
          ? searchForItem.productListItems
          : undefined
      "
      :title="'Search Product'"
      :gridOptions="{
        options: {
          pageSize: 50,
        },
      }"
    />

    <!-- Line Comment Popup  -->
    <DxPopup
      :visible.sync="lineCommentsPopupVisible"
      :drag-enabled="false"
      :close-on-outside-click="false"
      :show-title="true"
      title="Line Comment"
      :width="550"
      :height="310"
      :showCloseButton="false"
      :wrapperAttr="{ class: 'css-v2 gc-popup' }"
    >
      <div class="css-v2 gc-popup-form">
        <form>
          <DxForm
            :ref="'line-comments-form'"
            :customizeItem="customizeLineCommentItem"
            :form-data.sync="lineCommentModel"
            :items="lineCommentItems"
            :label-location="formsConfig.labelPosition"
          ></DxForm>
        </form>
      </div>

      <div class="footer">
        <DxButton
          text="Back"
          type="default"
          styling-mode="contained"
          @click="popupLineCommentBackButtonClick"
        />
      </div>
    </DxPopup>

    <!-- items history popup  -->
    <DxPopup
      :visible.sync="itemHistoryPopupVisible"
      :drag-enabled="false"
      :close-on-outside-click="true"
      :show-title="true"
      title="Customer Item History"
      :showCloseButton="false"
      :height="695"
      @hidden="itemHistoryPopupHidden"
      :wrapperAttr="{ class: 'css-v2 gc-popup' }"
    >
      <div class="css-v2 transaction-list">
        <dx-data-grid
          :data-source="customerItemHistoryDataSourceConfig"
          :height="590"
          :columns="customerItemHistoryColumns"
          @toolbar-preparing="itemHistoryToolbarPreparing($event)"
          ref="itemHistoryGrid"
          :allow-column-reordering="false"
          :column-chooser="{ enabled: false }"
          @content-ready="itemHistoryAddGridNoResults($event)"
        >
          <template #historyStatusTemplate="{ data }">
            <gc-status-chip :status="data.data.Status" />
          </template>

          <template #date-in-cell-template="{ data }">
            <gc-friendly-date :date="data.data.DateIn" />
          </template>

          <template #displayDescription="{ data }">
            <div class="informer">
              <GcHeaderContentDynamic
                :baseView="baseView"
                :primaryLabel="customerItemHistory['ProductDescription']"
                :secondaryLabel="customerItemHistory['ItemCode']"
                :viewMode="'popup'"
              />
            </div>
          </template>
        </dx-data-grid>
      </div>
      <div class="footer">
        <DxButton
          text="Back"
          type="default"
          styling-mode="contained"
          @click="itemHistoryPopupHidden"
        />
      </div>
    </DxPopup>
  </GcBaseLayout>
</template>

<script>
import RouteMixin from "@/_mixins/route.mixin";
import FormMixin from "@/_mixins/form.mixin";
import DataGridMixin from "@/_mixins/data-grid.mixin";
import {
  getDecimalFormat,
  // getDefaultCustomerSettings,
  getFactorByCode,
  getGlobalField,
} from "../../_store/helpers";
import { ProductService } from "../../_services/api/products/product.service";
import { CustomerDeliveryAddressService } from "../../_services/api/customers/customer-delivery-address.service";
import { DefaultCompanyBranchDivisionService } from "../../_services/api/sales/default-company-branch-dicision.service";
import { FeatureStorage } from "../../_services/storage";
import { SalesRepresentativeService } from "../../_services/api/sales/sales-rep.service";
import { CustomerService } from "../../_services/api/customers/customer.service";
import { CompanyService } from "../../_services/api/accounts/company.service";
import { CompanyCurrencyService } from "../../_services/api/accounts/company-currency.service";
import { SalesOrderV3Service } from "../../_services/api/sales/sales-order-v3.service";
import salesFormulas from "../../_helpers/formulas/sales-formulas";
import { SalesOrderService } from "../../_services/api/sales/sales-order.service";
import { SalesOrderNoteService } from "../../_services/api/sales/sales-order-note.service";
import { mapGetters } from "vuex";

import ArrayStore from "devextreme/data/array_store";
import validationEngine from "devextreme/ui/validation_engine";
import { SalesItemHistoryService } from "../../_services/api/sales/sale-item-history.service";

const {
  // calculateGrossProfitPcnt,
  // calculateSalesUMPriceForGP,
  calculateNetLineTotal,
  calculateWetLineTotal,
  calculateTaxableLineTotal,
  calculateTaxLineTotal,
  calculateLineTotal,
  calculateSalesUMNetFXPrice,
  calculateStockUMPrice,
  calculateStockUMNetPrice,
  calculateStockUMFXPrice,
  calculateStockUMQty,
  calculateStockUMNetFXPrice,
  calculateDiscLineTotal,
  calculateDiscFXLineTotal,
  calculateNetFXLineTotal,
  calculateWetFXLineTotal,
  calculateTaxableFXLineTotal,
  calculateTaxFXLineTotal,
  calculateFXLineTotal,
  calculateSalesUMNetPriceFromSalesUMNetFXPrice,
  calculateSalesUMPriceFromSalesUMFXPrice,
  calculateCalculatedDiscPcnt,
  // calculateSalesUMNetFXPriceFromSalesUMFXPrice,
} = salesFormulas;

function logDev() {
  // eslint-disable-next-line no-console
  console.log("CX LOG >>> ", ...arguments);
}

let productEntryBase = {
  ProductCode: "",
  ID: 1,
  IsEditing: false,
  IsBatchProduct: "No",
  BranchCode: undefined,
  BranchDescription: undefined,
  UnitOfMeasureCode: undefined,
  Onhand: undefined,
  AddDiscPriceGroupCode: undefined,
  AddDiscPricingMethod: undefined,
  AddDiscPricingMethodValue: undefined,
  AddDiscSalesUMPrice: undefined,
  AddDiscStockUMPrice: undefined,
  CalculatedDiscPcnt: undefined,
  Code: undefined,
  DiscFXLineTotal: 0,
  DiscLineTotal: 0,
  DiscPcnt: 0,
  ExTaxUnitCost: undefined,
  FXLineTotal: 0,
  IsCopyLine: false,
  IsNewLine: true,
  IsPrimeCostItem: false,
  ItemCode: undefined,
  ItemType: undefined,
  LineNo: 0,
  LineTotal: 0,
  NetFXLineTotal: 0,
  NetLineTotal: 0,
  PriceGroupCode: null,
  PriceGroupSalesUMPrice: 0,
  PriceGroupStockUMPrice: 0,
  PricingMethod: null,
  PricingMethodValue: 0,
  ProductDescription: undefined,
  SalesTaxPcnt: 0,
  SalesUM: undefined,
  SalesUMConversion: 0,
  SalesUMCost: 0,
  SalesUMFXPrice: 0,
  SalesUMIsVariable: false,
  SalesUMManufacturedCost: 0,
  SalesUMNetFXPrice: 0,
  SalesUMNetPrice: 0,
  SalesUMPrice: 0,
  SalesUMPromotionNetPrice: 0,
  SalesUMQty: 0,
  SalesUMStandardCost: 0,
  SalesUMStandardPrice: 0,
  StockUM: undefined,
  StockUMFXPrice: 0,
  StockUMManufacturedCost: 0,
  StockUMNetFXPrice: 0,
  StockUMNetPrice: 0,
  StockUMPrice: 0,
  StockUMQty: 0,
  StockUMStandardCost: 0,
  StockUMStandardPrice: 0,
  TaxCode: undefined,
  TaxFXLineTotal: 0,
  TaxLineTotal: 0,
  TaxableFXLineTotal: 0,
  TaxableLineTotal: 0,
  WetFXLineTotal: 0,
  WetLineTotal: 0,
  WetPcnt: 0,
  validCode: undefined,

  Comment: "",
  IsCommentVisible: false,
};
let deliveryAddressDataSourceItems = [];

export default {
  mixins: [RouteMixin, FormMixin, DataGridMixin],
  components: {},
  data() {
    return {
      loaded: false,
      setLoading: false,
      ui: {
        DateAdjustedMin: null,
        DateAdjustedMax: null,
      },

      factor368ExchangeRateFieldEditable: undefined,

      model: {
        CompanyCurrency: undefined,
        Status: "N",
        CustomStatus: undefined,
        FriendlyStatus: undefined,
        Code: null,

        CustomerCode: null,
        DateIn: new Date(),
        RequiredByDate: null,
        ShipDate: null,
        OrderNo: null,

        DeliveryAddressCompanyName: null,
        DeliveryAddressCountry: null,
        DeliveryAddressPostcode: null,
        DeliveryAddressState: null,
        DeliveryAddressStreetLine1: null,
        DeliveryAddressStreetLine2: null,
        DeliveryAddressSuburb: null,
        CustomerDeliveryAddressLineNo: undefined,

        ConsignmentNo: "",
        CurrencyCode: "",
        ExchangeRate: 1,

        BranchCode: null,
        DivisionCode: null,
        SalesOrderTypeCode: null,
        SalesRepresentativeCode: null,

        SalesOrderDetails: [],

        DateChanged: null,
        DateCreated: null,
        ChangedBy: null,
        CreatedBy: null,
        Notes: [],
        LineItemCode: undefined,
      },

      productDataSourceItems: [],
      productEntryLocalItems: new ArrayStore({
        key: "ID",
        data: [],
      }),

      salesUMsLocalData: [],
      changes: [],
      editRowKey: null,
      productListItems: undefined,
      searchForItem: {},
      validationLineData: undefined,
      showFooter: true,
      footerItems: [],
      productItemsLoaded: false,

      lineCommentsPopupVisible: false,

      lineCommentModel: {
        Comment: "",
        IsCommentVisible: false,
        ID: undefined,
      },

      itemHistoryPopupVisible: false,

      customerItemHistory: [],
      // addNewFormModel: {
      //   ProductCode: undefined,
      //   SalesUMQty: 0,
      //   DiscPcnt: 0,
      //   ProductDescription: undefined,
      //   SalesUM: undefined,
      //   SalesUMFXPrice: 0,
      //   SalesUMNetFXPrice: 0,
      //   TaxFXLineTotal: 0,
      //   TaxableFXLineTotal: 0,

      //   ItemType: undefined,
      //   ItemCode: undefined,
      //   ValidCode: false,
      // },
      addNewFormModel: { ...productEntryBase },
      holdValidation: false,
      headerFormHeight: "auto",
    };
  },

  async created() {
    this.$store.dispatch("ui/setGridExpand", false);
    this.showLoading(true);
    this.initialized();
  },
  async mounted() {},
  beforeDestroy() {
    this.$store.dispatch("dataContext/setSearchText", undefined);
  },

  computed: {
    addNewFormItems() {
      return [
        {
          itemType: "group",
          caption: "",
          colCount: 1,
          items: [
            {
              dataField: "ProductCode",
              label: {
                text: "Code",
              },
              editorOptions: {
                onValueChanged: (e) => {
                  if (!this.holdValidation)
                    this.onFormProductCodeValueChanged(e);
                },
                onEnterKey: (e) => {
                  if (!this.holdValidation) this.onFormProductCodeEnterKey(e);
                },
                onFocusOut: (e) => {
                  e.component.blur();
                },
                onFocusIn: async (e) => {
                  const headerToolbarForm =
                    await validationEngine.validateGroup(
                      "gc-form-header-toolbar"
                    );
                  if (!headerToolbarForm.isValid) {
                    this.setValidationComeBack("Customer");
                    this.displayValidationSummary(
                      headerToolbarForm.brokenRules
                    );
                  } else e.event.target.select();
                },
                onKeyDown: () => {
                  this.setHoldValidation(false);
                },
                onInitialized: (e) => {
                  if (this.model.CustomerCode) {
                    setTimeout(() => {
                      e.component.focus();
                    }, 1);
                  }
                },
              },
            },
            {
              dataField: "ProductDescription",
              label: {
                text: "Description",
              },
              editorOptions: {
                disabled: true,
              },
            },
            {
              dataField: "SalesUM",
              label: {
                text: "Sales UM",
              },
              editorType: "dxSelectBox",
              editorOptions: {
                onEnterKey: this.onFormSalesUMEnterKey,
                onValueChanged: (e) => {
                  if (this.addNewFormModel.SalesUMQty > 0)
                    this.onFormSalesUMQtyValueChanged(e);
                },
                displayExpr: "SalesUM",
                valueExpr: "SalesUM",
                searchExpr: ["SalesUM"],
                searchMode: "contains",
                showClearButton: true,
              },
            },
            {
              dataField: "SalesUMQty",
              label: {
                text: "Quantity",
              },
              editorOptions: {
                format: "##,###,###,###,##0.00",
                onValueChanged: this.onFormSalesUMQtyValueChanged,
                onEnterKey: this.onFormSalesUMQtyEnterKey,
                onFocusIn: async (e) => {
                  e.event.target.select();
                },
                step: 0,
              },
            },
            {
              dataField: "SalesUMFXPrice",
              label: {
                text: "Price",
              },
              editorOptions: {
                disabled: true,
                format: "##,###,###,###,##0.00",
              },
            },
            {
              dataField: "DiscPcnt",
              label: {
                text: "Discount",
              },
              editorOptions: {
                format: "##,###,###,###,##0.00 '%'",
                onValueChanged: this.onFormDiscPcntValueChanged,
                onEnterKey: this.onFormDiscPcntEnterKey,
                onFocusIn: async (e) => {
                  e.event.target.select();
                },
                step: 0,
              },
            },

            {
              dataField: "SalesUMNetFXPrice",
              label: {
                text: "Net Price",
              },
              editorOptions: {
                disabled: true,
                format: "##,###,###,###,##0.00",
              },
            },
            {
              dataField: "TaxFXLineTotal",
              label: {
                text: "Tax",
              },
              editorOptions: {
                disabled: true,
                format: "##,###,###,###,##0.00",
              },
            },
            {
              dataField: "TaxableFXLineTotal",
              label: {
                text: "Total",
              },
              editorOptions: {
                disabled: true,
                format: "##,###,###,###,##0.00",
              },
            },
          ],
        },
      ];
    },
    ...mapGetters({ gridHeight: "ui/getHeightForDataGrid" }),
    // ...mapGetters({ headerFormHeight: "ui/getHeaderFormHeight" }),
    ...mapGetters({ gridExpand: "ui/getGridExpand" }),
    ...mapGetters({
      getValidationSummaryVisible: "ui/getValidationSummaryVisible",
    }),

    getGridHeight() {
      if (this.headerFormHeight)
        return (
          this.gridHeight - (this.gridExpand ? 0 : this.headerFormHeight) - 60
        );
      else return this.gridHeight - 60;
    },
    backButtonRoute() {
      return "/sales-order";
    },
    getScreenJson() {
      var screenJson = {
        title: "Sales Order",
      };
      return screenJson;
    },
    getHeaderScreenJson() {
      return {
        headerFormVisible: true,
        deliveryAddressItems: [
          {
            itemType: "group",
            caption: "",
            colCount: 1,
            items: [
              {
                dataField: "DeliveryAddressCompanyName",
                editorType: "dxTextBox",
                label: {
                  text: "Name",
                },
                editorOptions: {
                  maxLength: "100",
                  readOnly: true,
                },
                // allowUpdate: false,
              },
              {
                screenField: "PhysicalAddressStreetLine1",
                dataField: "DeliveryAddressStreetLine1",
                editorOptions: {
                  maxLength: "50",
                  readOnly:
                    this.model.Status === "C" || this.model.Status === "X",
                },
                // allowUpdate: false,
              },
              {
                screenField: "PhysicalAddressStreetLine2",
                dataField: "DeliveryAddressStreetLine2",
                editorOptions: {
                  maxLength: "50",
                  readOnly:
                    this.model.Status === "C" || this.model.Status === "X",
                },
                // allowUpdate: false,
              },
              {
                screenField: "PhysicalAddressSuburb",
                dataField: "DeliveryAddressSuburb",
                editorOptions: {
                  maxLength: "50",
                  readOnly:
                    this.model.Status === "C" || this.model.Status === "X",
                },
                // allowUpdate: false,
              },
              {
                screenField: "PhysicalAddressState",
                dataField: "DeliveryAddressState",
                editorOptions: {
                  maxLength: "50",
                  readOnly:
                    this.model.Status === "C" || this.model.Status === "X",
                },
                // allowUpdate: false,
              },
              {
                screenField: "PhysicalAddressPostcode",
                dataField: "DeliveryAddressPostcode",
                editorOptions: {
                  maxLength: "50",
                  readOnly:
                    this.model.Status === "C" || this.model.Status === "X",
                },
                // allowUpdate: false,
              },
              {
                screenField: "PhysicalAddressCountry",
                dataField: "DeliveryAddressCountry",
                editorOptions: {
                  maxLength: "50",
                  readOnly:
                    this.model.Status === "C" || this.model.Status === "X",
                },
                // allowUpdate: false,
              },
            ],
          },
        ],
        headerToolbar: {
          audit: this.baseView.mode == "review",
          status: true,
          notes: true,
          notesItems: ["Order Comments", "Order Notes"],
          save: this.isSaveEnable,
          //   (this.baseView.mode != "edit" &&
          //     this.model.Status != "C" &&
          //     this.model.Status != "X") ||
          //   (this.baseView.mode == "edit" && this.model.Status != "C"),
          editURL: "/sales-order-v5",
          editCallBack: this.editSOCallBack,
          saveOptions: {
            items: this.baseView.id
              ? [
                  { text: "Draft", id: "D" },
                  { text: "Commit", id: "A", default: true },
                  { text: "Cancel", id: "X" },
                ]
              : [
                  { text: "Draft", id: "D" },
                  { text: "Commit", id: "A", default: true },
                ],
            keyExpr: "id",
            displayExpr: "text",
            dropDownOptions: {
              width: "150px",
            },
            saveKey: "NextStatus",
          },
          saveCallback: this.saveSalesOrder,
          screenName: "Sales Orders - All",
          pdf: this.baseView.mode == "review",

          toolbarFormItems: [
            {
              screenField: "Customer",
              dataField: "CustomerCode",
              cssClass: "toolbar-customer-label",
              editorOptions: {
                dropDownOptions: {
                  minWidth: 300,
                  elementAttr: {
                    id: "so-v4-customer-details",
                  },
                },
                width: 300,
                placeholder: "Customer Name",
                onValueChanged: this.onCustomerCodeValueChanged.bind(this),
                showClearButton: true,
                onItemClick: this.onCustomerCodeItemClicked.bind(this),
                elementAttr: {
                  id: "so-v4-customer-name",
                },
              },
              label: {
                text: "Customer",
                visible: false,
              },
              required: true,
              visible: this.baseView.mode != "review",
            },
          ],
          formContentReady: this.toolBarFormContentReady,
          auditItems: [
            {
              itemType: "group",
              caption: "",
              items: [
                {
                  dataField: "FormattedDateCreated",
                  label: { text: "Created By", location: "left" },
                  editorType: "dxTextBox",
                  editorOptions: {
                    // // disabled: true,
                  },
                },
                {
                  dataField: "FormattedDateChanged",
                  label: { text: "Changed By", location: "left" },
                  editorType: "dxTextBox",
                  editorOptions: {
                    // disabled: true,
                  },
                },
              ],
            },
          ],
          customStatus: {
            enabled: true,
            key: "CustomStatus",
          },
          // orderComments: {
          //   dataField: "SalesOrderTypeCode",
          //   endpoint: "SalesOrderType",
          //   toMatch: [
          //     "UserComment1",
          //     "UserComment2",
          //     "UserComment3",
          //     "UserComment4",
          //     "UserComment5",
          //     "UserComment6",
          //     "UserComment7",
          //     "UserComment8",
          //     "UserComment9",
          //     "UserComment10",
          //     "UserComment11",
          //     "UserComment12",
          //     "UserComment13",
          //     "UserComment14",
          //     "UserComment15",
          //     "UserComment16",
          //     "UserComment17",
          //     "UserComment18",
          //     "UserComment19",
          //     "UserComment20",
          //   ],
          // },
          // commentItems: [
          //   {
          //     itemType: "group",
          //     caption: "",
          //     items: [],
          //   },
          // ],
        },
        title: {
          // Credit # [CreditNote] for Invoice # [InvoiceNumber]
          createModeIsEditMode: true,
          primary: {
            primary: {
              dataField: undefined,
              text:
                this.baseView.mode == "create"
                  ? "Create Sales Order"
                  : "Sales Order # " + this.baseView.id,
            },
            secondary: {
              dataField: undefined,
              text: undefined,
            },
          },
          secondary: {
            dataField:
              this.baseView.mode == "create" ? undefined : "CustomerName",
            text: undefined,
          },
        },
        formItems: [
          {
            itemType: "group",
            caption: "",
            colCount: 3,
            items: [
              {
                itemType: "group",
                caption: "",
                items: [
                  {
                    screenField: "DateIn",
                    label: {
                      text: "Date In",
                    },
                    dataField: "DateIn",
                    required: true,
                    editorOptions: {
                      onValueChanged: this.onDateInValueChanged.bind(this),
                    },
                  },
                  {
                    screenField: "RequiredDate",
                    label: {
                      text: "Reqd Date",
                    },
                    dataField: "RequiredByDate",
                    required: true,
                    editorOptions: {
                      onValueChanged:
                        this.onRequiredByDateValueChanged.bind(this),
                    },
                  },
                  {
                    screenField: "ShipDate",
                    label: {
                      text: "Ship Date",
                    },
                    dataField: "ShipDate",
                    required: true,
                    editorOptions: {
                      onValueChanged: this.onShipDateValueChanged.bind(this),
                    },
                  },
                  {
                    screenField: "CustPO",
                    dataField: "OrderNo",
                    editorOptions: {
                      onValueChanged: this.onOrderNoChanged.bind(this),
                    },
                  },
                ],
              },
              {
                itemType: "group",
                caption: "",
                items: [
                  {
                    itemType: "group",
                    caption: "",
                    cssClass: "deliver-to",
                    items: [
                      {
                        screenField: "DeliverTo",
                        dataField: "DeliveryAddressCompanyName",
                        ref: "DeliveryAddressCompanyName",
                        required: true,
                        editorOptions: {
                          onItemClick: this.onDeliveryAddressChanged.bind(this),
                          // allowUpdate: true,
                        },
                        dataSourceConfig: {
                          // ingnore: true,
                          data: deliveryAddressDataSourceItems,
                        },
                        visible: this.baseView.mode != "review",
                      },
                      {
                        screenField:
                          this.baseView.mode != "review"
                            ? "DeliverTo"
                            : undefined,
                        dataField: "DeliveryAddressCompanyName",
                        ref: "DeliveryAddressCompanyName",
                        label: {
                          text: "Deliver To",
                        },
                        required: true,
                        visible: this.baseView.mode == "review",
                      },
                      {
                        screenField: "DeliveryCompanyView",
                        editAddress:
                          this.baseView.mode != "review" ? true : false,
                      },
                    ],
                  },
                  {
                    screenField: "ConNote",
                    dataField: "ConsignmentNo",
                  },
                  {
                    screenField: "CurrencyCode",
                    dataField: "CurrencyCode",
                    editorOptions: {
                      readOnly: true,
                    },
                  },
                  {
                    screenField: "ExchangeRate",
                    dataField: "ExchangeRate",
                    editorOptions: {
                      // TODO: Check the ReadOnly Logic
                      readOnly: true,
                      onValueChanged: this.onExchangeValueChanged,
                    },
                    required: true,
                    validationRules: [
                      {
                        type: "custom",

                        validationCallback: ({ value, rule }) => {
                          rule.message = `Exchange rate Cannot be 0 or Negative`;
                          return value > 0;
                        },
                      },
                    ],
                  },
                ],
              },

              {
                itemType: "group",
                caption: "",
                items: [
                  {
                    screenField:
                      this.baseView.mode != "review" ? "Branch" : undefined,
                    label: {
                      text: "Branch",
                    },
                    dataField:
                      this.baseView.mode != "review"
                        ? "BranchCode"
                        : "Branch.Description",
                    required: true,
                    editorOptions: {
                      onValueChanged: async (e) => {
                        await this.getSalesUMs(e.value);
                        this.triggerPriceChange(e);
                      },
                    },
                  },
                  {
                    screenField:
                      this.baseView.mode != "review" ? "Division" : undefined,
                    label: {
                      text: "Division",
                    },
                    dataField:
                      this.baseView.mode != "review"
                        ? "DivisionCode"
                        : "Division.Description",
                    required: true,
                    editorOptions: {
                      onValueChanged: this.triggerPriceChange.bind(this),
                    },
                  },
                  {
                    dataField:
                      this.baseView.mode != "review"
                        ? "SalesOrderTypeCode"
                        : "SalesOrderType.Description",
                    screenField:
                      this.baseView.mode != "review" ? "OrderType" : undefined,
                    label: {
                      text: "SO Type",
                    },
                    required: true,
                    editorOptions: {
                      onValueChanged: (e) => {
                        if (e.event) this.setOrderComments(e.value);
                        this.triggerPriceChange(e);
                      },
                    },
                  },
                  {
                    screenField:
                      this.baseView.mode != "review" ? "OrderRep" : undefined,
                    dataField:
                      this.baseView.mode != "review"
                        ? "SalesRepresentativeCode"
                        : "SalesRepresentativeFullName",
                    label: {
                      text: "Sales Rep",
                    },
                    required: true,
                    // defaultValue: this.getDefaultSalesRep,
                  },
                ],
              },
            ],
          },
        ],
      };
    },
    isSaveEnable() {
      if (this.baseView.mode == "create") return true;
      else {
        if (!this.loaded) return true;
        else if (this.model.Status == "C" || this.model.Status == "X")
          return false;
        else return true;
      }
    },
    getProductEntryColumns() {
      return [
        {
          caption: "Product",
          dataField: "ProductCode",
          showEditorAlways: false,
          // allowSearch: false,
          allowSorting: false,
          allowEditing: false,
          minWidth: 200,
          visible: this.dataViewType != "review",
          cssClass: "edit-cell-textbox-field",
          editorOptions: {
            elementAttr: {
              id: "so-v4-product-code",
            },
          },
          // renderAsync: true,
          fixedPosition: "left",
          fixed: true,
        },
        {
          caption: "Description",
          dataField: "ProductDescription",
          allowEditing: false,
          // renderAsync: true,
          minWidth: 220,
        },
        {
          caption: "Sales UM",
          dataField: "SalesUM",
          allowEditing: false,
          // renderAsync: true,
          width: 80,
          minWidth: 80,
        },
        {
          caption: "Quantity",
          dataField: "SalesUMQty",
          allowEditing: false,
          showEditorAlways: false,
          format: "##,###,###,###,##0.00",
          dataType: "number",
          // renderAsync: true,
          cssClass: "edit-cell-numberbox-field",
          editorOptions: {
            format: "##,###,###,###,##0.00",
          },
          width: 120,
          minWidth: 120,
        },
        {
          caption: "Price",
          dataField: "SalesUMFXPrice",
          allowEditing: false,
          format: "##,###,###,###,##0.00",
          width: 120,
          minWidth: 120,
          // renderAsync: true,
        },
        {
          caption: "Discount",
          dataField: "DiscPcnt",
          format: "##,###,###,###,##0.00 '%'",
          allowEditing: false,
          showEditorAlways: false,
          cssClass: "edit-cell-numberbox-field",
          // renderAsync: true,
          editorOptions: {
            format: "##,###,###,###,##0.00 '%'",
          },
          width: 120,
          minWidth: 120,
        },
        {
          caption: "Net Price",
          dataField: "SalesUMNetFXPrice",
          allowEditing: false,
          format: "##,###,###,###,##0.00",
          width: 120,
          minWidth: 120,
          // renderAsync: true,
        },
        {
          caption: "Tax",
          dataField: "TaxFXLineTotal",
          allowEditing: false,
          format: "##,###,###,###,##0.00",
          width: 120,
          minWidth: 120,
        },
        {
          caption: "Total",
          dataField: "TaxableFXLineTotal",
          allowEditing: false,
          format: "##,###,###,###,##0.00",
          // renderAsync: true,
          width: 120,
          minWidth: 120,
        },
        {
          caption: "",
          dataField: "",
          type: "buttons",
          buttons: ["delete"],
          visible: this.baseView.mode != "review",
        },
        {
          caption: "",
          dataField: "",
          width: 40,
          minWidth: 30,
          maxWidth: 80,
          allowEditing: false,
          cellTemplate: "menu-cell-template",
          alignment: "left",
          cssClass: "more-menu",
          fixedPosition: "right",
          fixed: true,
          allowFixing: true,
          allowReordering: false,
          allowSorting: false,
          allowSearch: false,
          allowFiltering: false,
          allowGrouping: false,
        },
      ];
    },
    // Footer
    getFooterItems() {
      return [
        {
          screenField: "SalesUMItemCount",
          dataField: "SalesUMQty",
          location: "left",
          value: 0,
        },
        {
          screenField: "FXLineTotal",
          dataField: "TaxableFXLineTotal",
          location: "right",
          value: 0,
          format: "Decimal-16-4C",
          label: `Sub Total (${this.model.CurrencyCode})`,
        },
        {
          screenField: "TaxFXTotal",
          dataField: "TaxFXLineTotal",
          location: "right",
          value: 0,
          format: "Decimal-16-4C",
          label: `Tax (${this.model.CurrencyCode})`,
        },
        {
          screenField: "FXTotal",
          dataField: "FXLineTotal",
          location: "right",
          value: 0,
          format: "Decimal-16-4C",
          label: `Total (${this.model.CurrencyCode})`,
        },
      ];
    },

    footerLeftItems() {
      var leftItems = this.footerItems.filter((x) => x.location == "left");

      return leftItems
        .map((c) => {
          let globalField = { ...getGlobalField(c.screenField) };
          if (Object.keys(globalField).length == 0) return c;

          if (c.value != undefined) globalField.value = c.value;
          if (c.dataField != undefined) globalField.dataField = c.dataField;
          if (c.label != undefined) globalField.label = c.label;
          if (c.format != undefined) globalField.format = c.format;
          if (c.fieldType != undefined) globalField.fieldType = c.fieldType;
          if (c.length != undefined) globalField.length = c.length;
          if (globalField.type === "Decimal") {
            globalField.label = globalField.label.replace(
              "(Customer Currency)",
              `(${this.model.CurrencyCode})`
            );
          }
          // if(c.length != undefined) globalField.length = c.length;
          if (globalField.type === "Decimal") {
            globalField.label = globalField.label.replace(
              "(Customer Currency)",
              `(${this.model.CurrencyCode})`
            );
          }
          if (globalField) return globalField;
          else return c;
        })
        .filter((x) => x != null);
    },
    footerRightItems() {
      // return this.footerItems.filter((x) => x.location == "right");
      var rightItems = this.footerItems.filter(
        (x) =>
          x.location == "right" &&
          (x.hasOwnProperty("visible") ? x.visible : true)
      );

      return rightItems
        .map((c) => {
          let globalField = { ...getGlobalField(c.screenField) };

          if (Object.keys(globalField).length == 0) return c;

          if (c.value != undefined) globalField.value = c.value;
          if (c.dataField != undefined) globalField.dataField = c.dataField;
          if (c.label != undefined) globalField.label = c.label;
          if (c.format != undefined) globalField.format = c.format;

          if (globalField.type === "Decimal") {
            globalField.label = globalField.label.replace(
              "(Customer Currency)",
              `(${this.model.CurrencyCode})`
            );
          }

          if (globalField) return globalField;
          else return c;
        })
        .filter((x) => x != null);
    },

    // Detail Lines
    lineCommentItems() {
      return [
        {
          itemType: "group",
          caption: "",
          colCount: 1,
          items: [
            {
              itemType: "group",
              caption: "",
              items: [
                {
                  dataField: "Comment",
                  editorType: "dxTextArea",
                  label: { visible: false },
                  editorOptions: {
                    height: "140",
                    maxLength: 1000,
                  },
                },
                {
                  dataField: "IsCommentVisible",
                  label: { text: "Visible On Invoice" },
                  editorType: "dxSwitch",
                },
                // {
                //   dataField: "ID",
                //   editorType: "dxNumberBox",
                //   editorOptions: {
                //     readOnly: true,
                //   },
                // },
              ],
            },
          ],
        },
      ];
    },

    customerItemHistoryDataSourceConfig() {
      if (!this.model.CustomerCode || !this.model.LineItemCode) {
        return;
      } else {
        return SalesItemHistoryService.dataSourceConfig({
          // select: ["Note", "LineNo", "SalesOrderCode"],
          sort: [{ selector: "SalesOrderCode", desc: true }],
          filter: [
            ["CustomerCode", "=", this.model.CustomerCode],
            "and",
            ["ItemType", "=", "S"],
            "and",
            ["ItemCode", "=", this.model.LineItemCode],
          ],
        });
      }
    },
    customerItemHistoryColumns() {
      return [
        {
          caption: "Order",
          dataField: "SalesOrderCode",
          alignment: "left",
          width: 130,
        },
        {
          caption: "Date",
          dataField: "DateIn",
          width: 150,
          cellTemplate: "date-in-cell-template",
          allowFiltering: false,
        },
        {
          caption: "Qty",
          dataField: "SalesUMQty",
          alignment: "right",
          format: getDecimalFormat("Decimal-16-2").ReadOnlyFormat,
          width: 150,
        },
        {
          caption: "UM",
          dataField: "SalesUM",
          alignment: "left",
          width: 100,
        },
        {
          caption: "Unit Price",
          dataField: "SalesUMNetPrice",
          alignment: "right",
          // format: this.getDecimalFormatByCode(13).Format,
          format: getDecimalFormat("Decimal-16-4C").ReadOnlyFormat,
          width: 150,
        },
        {
          caption: "Status",
          dataField: "FriendlyStatus",
          cellTemplate: "historyStatusTemplate",
          width: 100,
        },
        {
          caption: "Price Group",
          dataField: "PriceGroupDescription",
          alignment: "left",
        },
      ];
    },
  },
  methods: {
    setHoldValidation(value) {
      this.holdValidation = value;
    },
    clearAddNewProductRecord() {
      this.setHoldValidation(true);
      this.resetFormModel();
      // var dxform = this.$refs["dx-form-add-new-comp"].instance;
      this.resetFormFocus();
      // dxform.option("formData", Object.assign({}, this.addNewFormModel));
    },
    addNewProductRecord(e) {
      this.setHoldValidation(true);

      e.event.preventDefault();
      if (!this.addNewFormModel.ProductCode) {
        this.$store.dispatch("ui/setValidationSummaryVisible", true);
        this.setValidationComeBack("ProductCode", false);
        this.displayValidationErrors(["Product Code is required"]);
      } else {
        let dataObj = Object.assign({
          ...this.addNewFormModel,
        });
        this.addAndRefreshDataSource(dataObj);
      }
    },
    cellDblClick(e) {
      if (!e.data) return;

      e.data.IsEditing = true;

      this.addNewFormModel = { ...e.data };

      this.setSalesUMDataSource();

      var dxform = this.$refs["dx-form-add-new-comp"].instance;

      dxform.option("formData", Object.assign({}, this.addNewFormModel));

      var element = dxform.getEditor("ProductCode");
      element.focus();
    },
    resetFormModel() {
      this.addNewFormModel = {
        ...productEntryBase,
      };

      var maxID = Math.max(
        ...this.productEntryLocalItems._array.map((e) => e.ID)
      );

      if (maxID > 0) this.addNewFormModel.ID = ++maxID;
    },
    setSalesUMDataSource() {
      var salesUMs = this.salesUMsLocalData.filter((x) => {
        return (
          x.ItemCode == this.addNewFormModel.ItemCode &&
          x.ItemType == this.addNewFormModel.ItemType
        );
      });

      var dxform = this.$refs["dx-form-add-new-comp"].instance;

      var element = dxform.getEditor("SalesUM");
      element.option("dataSource", salesUMs);

      if (salesUMs.length <= 1) {
        element.option("disabled", true);

        var elementQty = dxform.getEditor("SalesUMQty");
        elementQty.focus();
      } else {
        element.option("disabled", false);
        element.focus();
      }
    },
    onFormProductCodeValueChanged(e) {
      if (!e.event) return;
      // this.resetFormModel();

      var index = this.productDataSourceItems.findIndex(
        (x) => x.ItemCode == e.value
      );

      if (index != -1) {
        var productItem = this.productDataSourceItems[index];

        this.addNewFormModel.ProductCode = productItem.ItemCode;
        this.addNewFormModel.ItemCode = productItem.ItemCode;
        this.addNewFormModel.ProductDescription = productItem.Description1;

        this.addNewFormModel.SalesUM = productItem.SalesUM;
        this.addNewFormModel.ItemType = productItem.ItemType;
        this.addNewFormModel.ValidCode = productItem.ItemCode;

        this.setSalesUMDataSource();
      } else {
        if (!this.productItemsLoaded) {
          this.showLoading(true);
          ProductService.getCustomData({
            url: "api/ProductFilterGroupSaleItemCompanyBranch",
            top: 1,
            filter: `ItemCode eq '${e.value}' and ItemType eq 'S' and IsDefault eq 'Y' and AvailableForSale eq 'Y' and BranchCode eq '${this.model.BranchCode}' and CustomerCode eq '${this.model.CustomerCode}' and Inactive eq 'N'`,
          })
            .then((res) => {
              this.showLoading(false);
              if (res.data.value.length > 0) {
                var productItem = res.data.value[0];
                this.addItemToProductDataSource(productItem);

                this.addNewFormModel.ProductCode = productItem.ItemCode;
                this.addNewFormModel.ItemCode = productItem.ItemCode;
                this.addNewFormModel.ProductDescription =
                  productItem.Description1;

                this.addNewFormModel.SalesUM = productItem.SalesUM;
                this.addNewFormModel.ItemType = productItem.ItemType;
                this.addNewFormItems.ValidCode = productItem.ItemCode;

                this.setSalesUMDataSource();

                // if (currentRowData.SalesUMQty > 0) {
                //   newData.SalesUMQty = currentRowData.SalesUMQty;
                //   this.getItemPriceDetails(newData, { ...newData });
                // }
              } else {
                if (this.addNewFormItems.ValidCode)
                  this.addNewFormItems.ProductCode =
                    this.addNewFormItems.ValidCode;

                this.$store.dispatch("ui/setValidationSummaryVisible", true);
                this.setValidationComeBack("ProductCode", false);
                this.displayValidationErrors([
                  "This Product does not exist. Please try again",
                ]);
              }
            })
            .catch((err) => {
              if (err);
              this.showLoading(false);
            });
        } else {
          e.event.preventDefault();
          this.addNewFormModel.ValidCode = false;
          this.addNewFormModel.ProductCode = e.previousValue;

          this.$store.dispatch("ui/setValidationSummaryVisible", true);
          this.setValidationComeBack("ProductCode", false);
          this.displayValidationErrors([
            "This Product does not exist. Please try again",
          ]);
        }
      }

      var dxform = this.$refs["dx-form-add-new-comp"].instance;
      dxform.option("formData", Object.assign({}, this.addNewFormModel));
    },
    onFormSalesUMQtyValueChanged(e) {
      if (!e.event) return;

      const DiscPcnt = this.addNewFormModel.DiscPcnt;

      if (this.addNewFormModel.ItemCode) {
        this.addNewFormModel.PriceLookUp = true;
        SalesOrderV3Service.setSaleItemPrice(
          // Non Grid List
          this.addNewFormModel,
          this.addNewFormModel,
          this.model.SalesOrderTypeCode,
          this.model.BranchCode,
          this.model.CustomerCode,
          this.model.ExchangeRate,
          this.model.DateIn,
          this.model.RequiredByDate,
          false
        ).then((res) => {
          var record = this.productEntryLocalItems._array.filter((x) => {
            return x.ID == res.ID && x.ItemCode == res.ItemCode;
          });

          if (
            (this.addNewFormModel.ItemCode &&
              this.addNewFormModel.ItemCode == res.ItemCode) ||
            record.length > 0
          ) {
            if (DiscPcnt) {
              if (record.length == 0) {
                this.addNewFormModel = {
                  ...this.addNewFormModel,
                  ...res,
                };
                this.addNewFormModel.DiscPcnt = DiscPcnt;
                this.setBaseCurrencyPriceFromFXPrice(
                  false,
                  true,
                  this.addNewFormModel
                );
              } else {
                res.DiscPcnt = DiscPcnt;

                this.setBaseCurrencyPriceFromFXPrice(true, false, res);
              }
            } else if (record.length > 0) {
              var data = {
                ...this.addNewFormModel,
                ...res,
              };
              this.productEntryLocalItems.push([
                {
                  type: "update",
                  data: data,
                  key: res.ID,
                },
              ]);

              this.setFooterItems(this.productEntryLocalItems._array);
            } else {
              var dxform = this.$refs["dx-form-add-new-comp"].instance;
              dxform.option(
                "formData",
                Object.assign({}, this.addNewFormModel)
              );
            }
          }

          // console.log("Then has been finished.");
        });
        // console.log("Waiting for then to finish.");
      }
    },
    onFormDiscPcntValueChanged(e) {
      if (!e.event) return;

      this.addNewFormModel.DiscPcnt = e.value;

      this.setBaseCurrencyPriceFromFXPrice(false, true, this.addNewFormModel);
    },
    onFormProductCodeEnterKey(e) {
      if (!e.event || this.getValidationSummaryVisible) return;

      e.event.preventDefault();
      e.component.blur();

      if (
        !this.addNewFormModel.ProductCode ||
        !this.addNewFormModel.ValidCode
      ) {
        this.$store.dispatch("ui/setValidationSummaryVisible", true);
        this.setValidationComeBack("ProductCode", false);
        this.displayValidationErrors(["Product Code is required"]);
        // return;
      } else {
        let dataObj = Object.assign({
          ...this.addNewFormModel,
        });
        this.addAndRefreshDataSource(dataObj);
      }
    },
    onFormSalesUMEnterKey(e) {
      this.onFormSalesUMQtyEnterKey(e);
    },
    onFormSalesUMQtyEnterKey(e) {
      if (!e.event || this.getValidationSummaryVisible) return;

      e.event.preventDefault();
      e.component.blur();

      if (
        !this.addNewFormModel.ProductCode ||
        !this.addNewFormModel.ValidCode
      ) {
        this.$store.dispatch("ui/setValidationSummaryVisible", true);
        this.setValidationComeBack("ProductCode", false);
        this.displayValidationErrors(["Product Code is required"]);
        return;
      } else {
        let dataObj = Object.assign({
          ...this.addNewFormModel,
        });

        this.addAndRefreshDataSource(dataObj);
      }
    },
    onFormDiscPcntEnterKey(e) {
      if (!e.event || this.getValidationSummaryVisible) return;

      e.event.preventDefault();
      e.component.blur();

      if (
        !this.addNewFormModel.ProductCode ||
        !this.addNewFormModel.ValidCode
      ) {
        this.$store.dispatch("ui/setValidationSummaryVisible", true);
        this.setValidationComeBack("ProductCode", false);
        this.displayValidationErrors(["Product Code is required"]);
        return;
      } else {
        let dataObj = Object.assign({
          ...this.addNewFormModel,
        });

        this.addAndRefreshDataSource(dataObj);
      }
    },
    addAndRefreshDataSource(dataObj) {
      var maxID = Math.max(
        ...this.productEntryLocalItems._array.map((e) => e.ID)
      );
      if (dataObj.SalesUMQty == 0) dataObj.SalesUMQty = 1;

      if (!dataObj.IsEditing) {
        if (maxID > 0) dataObj.ID = ++maxID;
        this.productEntryLocalItems.insert(dataObj).then((res) => {
          if (res.SalesUMFXPrice == 0 && !this.addNewFormModel.PriceLookUp)
            this.getItemPriceDetails(res, { ...res });
          if (res.DiscPcnt > 0)
            this.setBaseCurrencyPriceFromFXPrice(true, false, res);

          if (this.$refs["dx-data-grid-comp"]) {
            var dataGrid = this.$refs["dx-data-grid-comp"].instance;

            dataGrid.clearSelection();
            dataGrid.option("focusedRowIndex", -1);
            dataGrid.refresh(true).then(() => {
              this.setFooterItems(this.productEntryLocalItems._array);

              this.scrollToLastRecord();
            });
          }
        });
      } else {
        this.productEntryLocalItems.update(dataObj.ID, dataObj).then((res) => {
          if (res.SalesUMFXPrice == 0)
            this.getItemPriceDetails(res, { ...res });
          if (res.DiscPcnt > 0)
            this.setBaseCurrencyPriceFromFXPrice(true, false, res);

          if (this.$refs["dx-data-grid-comp"]) {
            var dataGrid = this.$refs["dx-data-grid-comp"].instance;
            dataGrid.refresh(true).then(() => {
              this.setFooterItems(this.productEntryLocalItems._array);

              this.scrollToLastRecord();
            });
          }
        });
      }

      this.resetFormFocus();
    },
    scrollToLastRecord() {
      if (this.$refs["dx-data-grid-comp"]) {
        var dataGrid = this.$refs["dx-data-grid-comp"].instance;

        var scrollableView = dataGrid.getScrollable();

        scrollableView.scrollBy({
          left: 0,
          top: scrollableView.scrollHeight(),
        });
      }
    },
    resetFormFocus() {
      this.resetFormModel();
      var dxform = this.$refs["dx-form-add-new-comp"].instance;
      dxform.getEditor("ProductCode").focus();
      // dxform.focus();

      dxform.option("formData", Object.assign({}, this.addNewFormModel));

      // dxform.repaint();
      // console.log("You have been reset.");
      // var element = dxform.getEditor("ProductCode");

      // element.off("enterKey");
      // element.reset();
      // element.repaint();
      // setTimeout(function () {
      // element.focus();
      // }, 1);
    },
    addItemToProductDataSource(item) {
      this.productDataSourceItems.push(item);
    },
    setValidationComeBack(data, field) {
      this.validationLineData = data;
      this.validationDataField = field;
    },
    async updateLocalDataSet(type, dataObj, nextKey, params) {
      if (type == "insert") {
        if (
          this.productEntryLocalItems._array.length != 0 &&
          this.productEntryLocalItems._array[
            this.productEntryLocalItems._array.length - 1
          ].Code
        ) {
          this.productEntryLocalItems.insert(dataObj);
        } else if (this.productEntryLocalItems._array.length == 0) {
          this.productEntryLocalItems.insert(dataObj);
        }
      } else if (type == "update") {
        this.productEntryLocalItems.update(dataObj.ID, dataObj);
      }

      // await this.setStockPrices(dataObj);
      // await this.setLineTotals(dataObj);

      this.setFooterItems(this.productEntryLocalItems._array);

      if (type != "update") {
        setTimeout(() => {
          var dataGrid = this.$refs["dx-data-grid-comp"].instance;
          dataGrid
            .refresh()
            .then(() => {
              if (nextKey == "product-search") {
                this.visibleProductSearchCallBack(params.item);
              } else if (type == "insert") {
                dataGrid.navigateToRow(dataObj.ID);
                var rowIndex = dataGrid.getRowIndexByKey(dataObj.ID);
                var cellElement = dataGrid.getCellElement(
                  rowIndex,
                  "ProductCode"
                );
                dataGrid.focus(cellElement);
                dataGrid.editCell(rowIndex, "ProductCode");
              }
            })
            .catch(() => {
              dataGrid.navigateToRow(dataObj.ID);
              var rowIndex = dataGrid.getRowIndexByKey(dataObj.ID);

              if (rowIndex != -1) {
                var cellElement = dataGrid.getCellElement(
                  rowIndex,
                  "ProductCode"
                );
                dataGrid.focus(cellElement);
                dataGrid.editCell(rowIndex, "ProductCode");
              } else this.refreshDataGrid(type, dataObj, nextKey, params);
            });
        }, 250);
      }
    },
    refreshDataGrid(type, dataObj, nextKey, params) {
      var dataGrid = this.$refs["dx-data-grid-comp"].instance;
      dataGrid.refresh().then(() => {
        if (nextKey == "product-search") {
          this.visibleProductSearchCallBack(params.item);
        } else if (type == "insert") {
          dataGrid.navigateToRow(dataObj.ID);
          var rowIndex = dataGrid.getRowIndexByKey(dataObj.ID);
          var cellElement = dataGrid.getCellElement(rowIndex, "ProductCode");
          dataGrid.focus(cellElement);
          dataGrid.editCell(rowIndex, "ProductCode");
        }
      });
    },
    backButtonFunction() {
      this.$router
        .push({
          path: this.backButtonRoute,
        })
        .then(() => {
          this.$store.dispatch("dataContext/setDataViewType", undefined);
        });
    },
    toolBarFormContentReady(e) {
      if (e && this.baseView.mode != "review" && this.loaded)
        setTimeout(() => {
          var headerToolBarForm = e.component;
          if (headerToolBarForm && headerToolBarForm.getEditor("CustomerCode"))
            headerToolBarForm.getEditor("CustomerCode").instance().focus();
        }, 500);
    },
    async getItemPriceDetails(newData, currentRowData) {
      const DiscPcnt = newData.DiscPcnt;
      SalesOrderV3Service.setSaleItemPrice(
        // Non Grid List
        newData,
        currentRowData,
        this.model.SalesOrderTypeCode,
        this.model.BranchCode,
        this.model.CustomerCode,
        this.model.ExchangeRate,
        this.model.DateIn,
        this.model.RequiredByDate,
        false

        // eslint-disable-next-line no-unused-vars
      ).then((res) => {
        if (DiscPcnt) {
          res.DiscPcnt = DiscPcnt;

          this.setBaseCurrencyPriceFromFXPrice(true, false, res);
        } else {
          this.productEntryLocalItems.push([
            {
              type: "update",
              data: res,
              key: res.ID,
            },
          ]);

          this.setFooterItems(this.productEntryLocalItems._array);
        }

        // this.updateLocalDataSet("update", res);
      });
    },

    setSaleItemPriceAllLines() {
      if (this.productEntryLocalItems._array.length > 0) {
        var promises = [];
        for (var i = 0; i < this.productEntryLocalItems._array.length; i++) {
          var record = this.productEntryLocalItems._array[i];
          if (record.ItemCode)
            promises.push(
              SalesOrderV3Service.setSaleItemPrice(
                // REPRICE ALL
                record,
                record,
                this.model.SalesOrderTypeCode,
                this.model.BranchCode,
                this.model.CustomerCode,
                this.model.ExchangeRate,
                this.model.DateIn,
                new Date(this.model.RequiredByDate),
                false
              )
            );
        }

        Promise.all(promises).then((data) => {
          // this.$logger.debug("All SO details line prices are set");
          // that.refreshView();
          // console.log(">>>> ", data);
          data.forEach((element) => {
            this.updateLocalDataSet("update", element);
          });
        });
      }
    },

    triggerPriceChange(e) {
      // alert("Price Change Trigger logic" , e);
      if (e.event) this.setSaleItemPriceAllLines();
    },

    async setDeliveryAddressDataSourceItems(customerCode, lineNo) {
      logDev("customerCode", customerCode);
      let deliveryAddresDs = CustomerDeliveryAddressService.dataSourceConfig(
        "api/CustomerDeliveryAddress",
        {
          select: [
            "CompanyName",
            "PhysicalAddressStreetLine1",
            "PhysicalAddressStreetLine2",
            "PhysicalAddressSuburb",
            "PhysicalAddressState",
            "PhysicalAddressPostcode",
            "PhysicalAddressCountry",
            "RecordId",
            "LineNo",
          ],
          key: "RecordId",
          filter: [
            ["Inactive", "=", "N"],
            "and",
            ["CustomerCode", "=", customerCode],
          ],
        }
      );

      let results = await deliveryAddresDs.load();

      let defaultLineNo = 1;
      if (lineNo) defaultLineNo = lineNo;
      let deliveryAddressLine1Record = results.find(
        (x) => x.LineNo == defaultLineNo
      );

      if (deliveryAddressLine1Record) {
        deliveryAddressDataSourceItems = results;
        if (this.DeliveryAddressCompanyNameEditor()) {
          this.DeliveryAddressCompanyNameEditor().beginUpdate();
          this.DeliveryAddressCompanyNameEditor().option(
            "items",
            deliveryAddressDataSourceItems
          );
          this.DeliveryAddressCompanyNameEditor().option(
            "value",
            deliveryAddressLine1Record.CompanyName
          );
          this.DeliveryAddressCompanyNameEditor().endUpdate();
        }

        if (!lineNo) {
          this.model.DeliveryAddressCompanyName =
            deliveryAddressLine1Record.CompanyName;

          this.model.DeliveryAddressCountry =
            deliveryAddressLine1Record.PhysicalAddressCountry;
          this.model.DeliveryAddressPostcode =
            deliveryAddressLine1Record.PhysicalAddressPostcode;
          this.model.DeliveryAddressState =
            deliveryAddressLine1Record.PhysicalAddressState;
          this.model.DeliveryAddressStreetLine1 =
            deliveryAddressLine1Record.PhysicalAddressStreetLine1;
          this.model.DeliveryAddressStreetLine2 =
            deliveryAddressLine1Record.PhysicalAddressStreetLine2;
          this.model.DeliveryAddressSuburb =
            deliveryAddressLine1Record.PhysicalAddressSuburb;
          this.model.CustomerDeliveryAddressLineNo =
            deliveryAddressLine1Record.LineNo;
        }
      }
    },

    // Start - Details Data Grid Functions

    onSoDetailsLineContextMenuItemClick(e) {
      if (e.itemData.menuText == "Line Comment") {
        let rowData = e.itemData.data.data;

        let visibleOnInvoiceFactor = getFactorByCode(505);

        this.lineCommentModel.ID = rowData.ID;
        this.lineCommentModel.Comment = rowData.Comment;
        this.lineCommentModel.IsCommentVisible =
          rowData.LineNo == 0
            ? visibleOnInvoiceFactor.Factorc == "Y"
              ? true
              : rowData.IsCommentVisible
            : rowData.IsCommentVisible;

        this.lineCommentsPopupVisible = true;
      } else if (e.itemData.menuText == "Item History") {
        this.model.LineItemCode = e.itemData.data.data.ItemCode;
        this.customerItemHistory = e.itemData.data.data;
        this.itemHistoryPopupVisible = true;
        this.$logger.trackEventOpenPopup("Sales Order Item History");
      }
    },

    customizeLineCommentItem(item) {
      if (item.itemType == "simple") {
        item.editorOptions = item.editorOptions || {};
        if (item.dataField == "Comment") {
          item.editorOptions.readOnly = this.baseView.mode == "review";
        } else {
          item.editorOptions.disabled = this.baseView.mode == "review";
        }
      }
    },

    itemHistoryPopupHidden() {
      this.model.LineItemCode = undefined;
      this.$refs["itemHistoryGrid"].instance.clearFilter("search");

      this.itemHistoryPopupVisible = false;
    },

    itemHistoryToolbarPreparing(e) {
      e.toolbarOptions.items.unshift({
        location: "before",
        template: "displayDescription",
      });
    },

    itemHistoryAddGridNoResults(e) {
      let noDataMessageObject = {
        addNew: {
          class: undefined,
          title: "No History Lines",
          message:
            "Products despatched and invoiced to the customer will show here. Head over to the Despatch Order screen to despatch and invoice orders for this customer.",
        },
      };
      this.addGridNoResults(e, noDataMessageObject);
    },

    popupLineCommentBackButtonClick() {
      this.lineCommentsPopupVisible = false;

      this.updateLocalDataSet("update", {
        Comment: this.lineCommentModel.Comment,
        IsCommentVisible: this.lineCommentModel.IsCommentVisible,
        ID: this.lineCommentModel.ID,
      });
    },
    onContentReady() {
      setTimeout(() => {
        this.headerFormHeight =
          this.$refs["gc-header-form-component"].$el.clientHeight;
      }, 50);
    },
    onRowRemoved() {
      this.setFooterItems(this.productEntryLocalItems._array);
      this.resetFormModel();
      // if (this.productEntryLocalItems._array.length == 0) {
      //   let dataObj = Object.assign(
      //     { IsCopyLine: false, IsNewLine: true },
      //     productEntryBase
      //   );

      //   // dataObj.ID = index + 1;

      //   // this.productEntryLocalItems.push([{ type: "insert", data: dataObj }]);
      //   this.updateLocalDataSet("insert", dataObj);
      // }
    },
    onToolbarPreparing(e) {
      e.toolbarOptions.items.push({
        location: "before",
        widget: "dxButton",
        options: {
          icon: undefined,
          text: "Search",
          elementAttr: {
            class: "cx-color-button",
          },
          onClick: () => {
            this.visibleProductSearch();
          },
          visible: this.baseView.mode != "review",
        },
      });

      e.toolbarOptions.items.push({
        location: "after",
        locateinmenu: "auto",
        widget: "dxButton",
        // visible: !this.isTablet,
        options: {
          icon: this.gridExpand ? "collapse" : "expand",
          onClick: this.expandGrid,
          elementAttr: {
            id: "so-v4-grid-expand",
          },
        },
      });
    },
    expandGrid() {
      this.$store.dispatch("ui/setGridExpand", !this.gridExpand);
      setTimeout(() => {
        var dataGrid = this.$refs["dx-data-grid-comp"].instance;

        dataGrid.beginUpdate();
        dataGrid.updateDimensions();
        dataGrid.endUpdate();

        dataGrid.refresh(true);
      }, 500);
    },

    async visibleProductSearch() {
      const headerToolbarForm = await validationEngine.validateGroup(
        "gc-form-header-toolbar"
      );
      if (!headerToolbarForm.isValid) {
        this.validationLineData = "Customer";
        this.displayValidationSummary(headerToolbarForm.brokenRules);
      } else {
        this.searchForItem = {
          visible: true,
          popUpCallBack: this.visibleProductSearchCallBack,
          productListQuery: {
            endpoint: "ProductFilterGroupSaleItemCompanyBranch",
            // filter: `ItemType eq 'S' and IsDefault eq 'Y' and AvailableForSale eq 'Y' and BranchCode eq '${this.model.BranchCode}' and CustomerCode eq '${this.model.CustomerCode}' and Inactive eq 'N'`,
            select: [
              "ItemCode",
              "Description1",
              "BranchCode",
              "CustomerCode",
              "Inactive",
              "ItemType",
              "SalesUM",
              "StockUM",
            ],
            filter: [
              ["ItemType", "=", "S"],
              "and",
              ["AvailableForSale", "=", "Y"],
              "and",
              ["BranchCode", "=", `${this.model.BranchCode}`],
              "and",
              ["CustomerCode", "=", `${this.model.CustomerCode}`],
              "and",
              ["Inactive", "=", "N"],
            ],
            serverPaging: true,
            allowGrouping: false,
          },
          columns: [
            {
              screenField: "Comments",
              label: "Product",
              dataField: "ItemCode",
            },
            {
              screenField: "Comments",
              label: "Description",
              dataField: "Description1",
            },
          ],
          // productListItems: this.productListItems,
        };
      }
    },
    async visibleProductSearchCallBack(productItem, productListItems) {
      if (productListItems) this.productListItems = productListItems;
      this.searchForItem = {
        visible: false,
        popUpCallBack: this.visibleProductSearchCallBack,
        productListItems: productListItems,
      };
      if (productItem) {
        this.resetFormModel();

        this.addNewFormModel.ProductDescription = productItem.Description1;
        this.addNewFormModel.ProductCode = productItem.ItemCode;
        this.addNewFormModel.SalesUM = productItem.SalesUM;
        this.addNewFormModel.ItemCode = productItem.ItemCode;
        this.addNewFormModel.ItemType = productItem.ItemType;
        this.addNewFormModel.ValidCode = productItem.ItemCode;

        // this.addNewFormModel = {
        //   ...this.addNewFormModel,
        //   ...productItem,
        // };

        var dxform = this.$refs["dx-form-add-new-comp"].instance;
        dxform.option("formData", Object.assign({}, this.addNewFormModel));

        // var editor = dxform.getEditor("SalesUMQty");
        // editor.focus();

        this.setSalesUMDataSource();
      }
    },

    async setBaseCurrencyPriceFromFXPrice(updateGrid, updateForm, record) {
      if (!record) return;

      record.SalesUMNetFXPrice = calculateSalesUMNetFXPrice(
        record.SalesUMFXPrice,
        record.DiscPcnt
      );

      record.SalesUMPrice = calculateSalesUMPriceFromSalesUMFXPrice(
        record.SalesUMFXPrice,
        this.model.ExchangeRate
      );

      record.CalculatedDiscPcnt = calculateCalculatedDiscPcnt(
        record.SalesUMStandardPrice,
        record.SalesUMPrice
      );

      record.SalesUMNetPrice = calculateSalesUMNetPriceFromSalesUMNetFXPrice(
        record.SalesUMNetFXPrice,
        this.model.ExchangeRate
      );

      await this.setStockPrices(record);
      await this.setLineTotals(record);

      if (updateForm && this.addNewFormModel.ItemCode == record.ItemCode) {
        this.addNewFormModel = {
          ...this.addNewFormModel,
          ...record,
        };

        var dxform = this.$refs["dx-form-add-new-comp"].instance;
        dxform.option("formData", Object.assign({}, this.addNewFormModel));
      }

      if (updateGrid) {
        this.productEntryLocalItems.push([
          {
            type: "update",
            data: record,
            key: record.ID,
          },
        ]);

        this.setFooterItems(this.productEntryLocalItems._array);
      }

      // this.productEntryLocalItems.update(record.ID, record);

      // this.updateLocalDataSet("update", record);
    },

    setStockPrices(record) {
      record.StockUMQty = calculateStockUMQty(
        record.SalesUMQty,
        record.SalesUMConversion
      );

      // Stock
      record.StockUMFXPrice = calculateStockUMFXPrice(
        record.SalesUMFXPrice,
        record.SalesUMConversion
      );

      record.StockUMNetFXPrice = calculateStockUMNetFXPrice(
        record.SalesUMNetFXPrice,
        record.SalesUMConversion
      );

      record.StockUMPrice = calculateStockUMPrice(
        record.SalesUMPrice,
        record.SalesUMConversion
      );

      record.StockUMNetPrice = calculateStockUMNetPrice(
        record.SalesUMNetPrice,
        record.SalesUMConversion
      );
    },
    setLineTotals(record) {
      // FX Totals
      record.DiscFXLineTotal = calculateDiscFXLineTotal(
        record.SalesUMFXPrice,
        record.SalesUMNetFXPrice,
        record.SalesUMQty
      );
      record.NetFXLineTotal = calculateNetFXLineTotal(
        record.SalesUMNetFXPrice,
        record.SalesUMQty
      );
      record.WetFXLineTotal = calculateWetFXLineTotal(
        record.NetFXLineTotal,
        record.WetPcnt
      );

      record.TaxableFXLineTotal = calculateTaxableFXLineTotal(
        record.NetFXLineTotal,
        record.WetFXLineTotal
      );
      record.TaxFXLineTotal = calculateTaxFXLineTotal(
        record.NetFXLineTotal,
        record.WetFXLineTotal,
        record.SalesTaxPcnt
      );
      record.FXLineTotal = calculateFXLineTotal(
        record.TaxableFXLineTotal,
        record.TaxFXLineTotal
      );

      // Totals
      record.DiscLineTotal = calculateDiscLineTotal(
        record.DiscFXLineTotal,
        this.model.ExchangeRate
      );
      record.NetLineTotal = calculateNetLineTotal(
        record.NetFXLineTotal,
        this.model.ExchangeRate
      );
      record.WetLineTotal = calculateWetLineTotal(
        record.WetFXLineTotal,
        this.model.ExchangeRate
      );
      record.TaxableLineTotal = calculateTaxableLineTotal(
        record.TaxableFXLineTotal,
        this.model.ExchangeRate
      );
      record.TaxLineTotal = calculateTaxLineTotal(
        record.TaxFXLineTotal,
        this.model.ExchangeRate
      );
      record.LineTotal = calculateLineTotal(
        record.FXLineTotal,
        this.model.ExchangeRate
      );
      // window.ViewModel.calculateComputedFields();
    },
    onEditorPreparing(e) {
      if (e.editorOptions && e.editorOptions.onValueChanged) {
        let func = e.editorOptions.onValueChanged;
        if (this.baseView.mode != "review" && e.parentType != "searchPanel")
          e.editorOptions.onValueChanged = (event) => {
            func(event, {
              column: {
                dataField: e.dataField,
              },
              data: e.row.data,
              rowIndex: e.row.rowIndex,
            });
          };
      }

      if (e.editorOptions && e.editorOptions.onKeyDown) {
        let func = e.editorOptions.onKeyDown;
        if (this.baseView.mode != "review" && e.parentType != "searchPanel")
          e.editorOptions.onKeyDown = (event) => {
            func(event, {
              column: {
                dataField: e.dataField,
              },
              data: e.row.data,
              rowIndex: e.row.rowIndex,
            });
          };
      }
    },
    onRowPrepared() {
      // if (e.rowType == "data") {
      //   if (e.data.IsNewLine) {
      //     e.data.IsNewLine = false;
      //     var dataGrid = e.component;
      //     if (this.model.CustomerCode)
      //       setTimeout(() => {
      //         var cellElement = dataGrid.getCellElement(
      //           e.rowIndex,
      //           "ProductCode"
      //         );
      //         dataGrid.focus(cellElement);
      //         dataGrid.editCell(e.rowIndex, "ProductCode");
      //         dataGrid.navigateToRow(e.data.ID);
      //       }, 100);
      //   }
      // }
    },
    async setProductDataSourceItems() {
      this.productDataSourceItems = [];
      var totalItemsCount = 0;
      this.setLoading = true;

      await ProductService.getCustomData({
        url: "api/ProductFilterGroupSaleItemCompanyBranch",
        count: true,
        top: 1000,
        filter: `ItemType eq 'S' and IsDefault eq 'Y' and AvailableForSale eq 'Y' and BranchCode eq '${this.model.BranchCode}' and CustomerCode eq '${this.model.CustomerCode}' and Inactive eq 'N'`,
      }).then((res) => {
        totalItemsCount = res.data["@odata.count"];

        this.productDataSourceItems = this.productDataSourceItems.concat(
          res.data.value
        );
        this.reCallProdcutItemsList(totalItemsCount, 1000, 1000);
      });
      this.setLoading = false;
    },
    async reCallProdcutItemsList(totalItemsCount, top, skip) {
      if (skip < totalItemsCount)
        await ProductService.getCustomData({
          url: "api/ProductFilterGroupSaleItemCompanyBranch",
          count: true,
          top: top,
          skip: skip,
          filter: `ItemType eq 'S' and IsDefault eq 'Y' and AvailableForSale eq 'Y' and BranchCode eq '${this.model.BranchCode}' and CustomerCode eq '${this.model.CustomerCode}' and Inactive eq 'N'`,
        }).then((res) => {
          this.productDataSourceItems = this.productDataSourceItems.concat(
            res.data.value
          );

          this.reCallProdcutItemsList(totalItemsCount, 1000, skip + 1000);
        });
      else this.productItemsLoaded = true;
    },
    // End - Details Data Grid Functions

    // Start - Header Form Functions
    HeaderFormInstance() {
      if (this.loaded)
        return this.$refs["gc-header-form-component"].$refs["gc-header-form"]
          .$refs["gc-form-comp"].instance;
    },
    DeliveryAddressCompanyNameEditor() {
      if (this.loaded) {
        return this.HeaderFormInstance().getEditor(
          "DeliveryAddressCompanyName"
        );
      }
    },
    ExchangeRateEditor() {
      return this.HeaderFormInstance().getEditor("ExchangeRate");
    },

    async onCustomerCodeValueChanged(e) {
      if (!e.value) this.model.CustomStatus = null;

      if (!e.value && e.event) {
        this.model.DeliveryAddressCompanyName = "";
        this.model.DeliveryAddressCountry = "";
        this.model.DeliveryAddressPostcode = "";
        this.model.DeliveryAddressState = "";
        this.model.DeliveryAddressStreetLine1 = "";
        this.model.DeliveryAddressStreetLine2 = "";
        this.model.DeliveryAddressSuburb = "";
        this.DeliveryAddressCompanyNameEditor().option("dataSource", []);
        return;
      }

      if (!e.event && e.value) {
        this.setDeliveryAddressDataSourceItems(e.value);
      }

      this.triggerPriceChange(e);
    },

    async onCustomerCodeItemClicked(e) {
      if (e.itemData.StopCredit == "Y") this.model.CustomStatus = "Credit Hold";
      else this.model.CustomStatus = undefined;

      let customerRecord = e.itemData;
      if (!customerRecord) {
        return;
      }

      this.showLoading(true);
      this.model.CustomerCode = customerRecord.Code;
      this.model.CurrencyCode = customerRecord.CurrencyCode;
      this.model.CustomerName = customerRecord.Name;

      this.setFooterItems(this.productEntryLocalItems._array);
      await this.setProductDataSourceItems();

      this.setExchangeRateProperties();
      await this.setDeliveryAddressDataSourceItems(this.model.CustomerCode);

      var dxform = this.$refs["dx-form-add-new-comp"].instance;
      var element = dxform.getEditor("ProductCode");
      element.focus();

      this.showLoading(false);
    },

    async setExchangeRateProperties() {
      let isEditable = false;

      if (
        !(
          this.baseView.mode == "review" ||
          this.factor368ExchangeRateFieldEditable == "N"
        )
      ) {
        isEditable = this.model.CompanyCurrency != this.model.CurrencyCode;
      }

      if (this.ExchangeRateEditor())
        this.ExchangeRateEditor().option("readOnly", !isEditable);

      if (this.model.CompanyCurrency != this.model.CurrencyCode) {
        let result = await CompanyCurrencyService.getByCurrencyCode(
          this.model.CurrencyCode
        );
        this.model.ExchangeRate = result.data.value[0].BuyRate;
      } else {
        this.model.ExchangeRate = 1;
      }
    },

    async onExchangeValueChanged(e) {
      if (!e.event) return;
      // if (this.isExchangeReverting) {
      //   this.isExchangeReverting = false;
      //   return;
      // }
      // if (e.value === 0) {
      //   this.displayValidationSummary([
      //     "Exchange rate should be greater than 0.0000",
      //   ]);
      //   this.isExchangeReverting = true;
      //   this.model.ExchangeRate = e.previousValue;
      // } else {
      //   this.setCompanyCurrencyPriceAllLines();
    },

    async onDeliveryAddressChanged(e) {
      this.model.CustomerDeliveryAddressLineNo = e.itemData.LineNo;
    },

    async onOrderNoChanged(e) {
      if (!e.event) return;
    },
    async onShipDateValueChanged(e) {
      if (!e.event) return;
    },
    async onRequiredByDateValueChanged(e) {
      if (!e.event) return;
      let factor565ShipDateSameAsRequiredByDate = getFactorByCode(565);

      if (factor565ShipDateSameAsRequiredByDate.Factorc == "Y") {
        this.model.ShipDate = e.value;
      }
      if (getFactorByCode(616).Factorc != "Date In") {
        this.triggerPriceChange(e);
      }
    },
    async onDateInValueChanged(e) {
      if (!e.event) return;
      if (e.event && getFactorByCode(616).Factorc == "Date In") {
        this.triggerPriceChange(e);
      }
    },
    // End - Header Form Functions

    // Start - On initialized Functions
    async initialized() {
      this.setFooterItems([]);
      if (this.baseView.mode == "create") {
        // for (let index = 0; index < 5; index++) {
        //   let dataObj = Object.assign(
        //     { IsCopyLine: false, IsNewLine: true },
        //     productEntryBase
        //   );

        //   dataObj.ID = index + 1;

        //   this.productEntryLocalItems.insert(dataObj);
        // }

        // Factors from SO-v1
        // await this.$store.dispatch(
        //   "screenFactors/getFactors",
        //   [616, 549, 550, 505, 95, 87, 565, 571, 655, 643, 368, 639, 578]
        // );

        await this.$store.dispatch(
          "screenFactors/getFactors",
          [616, 549, 550, 95, 87, 565, 368, 18, 65, 505, 66]
        );

        await this.setDefaultSalesRep();

        this.factor368ExchangeRateFieldEditable = getFactorByCode(368);

        //  Populate defaults in the Create Mode
        this.model.DateIn = new Date();
        this.model.Status = "D";
        this.model.Code = 0;

        this.model.CompanyCode = getFactorByCode(18).Factorc;
        this.model.BranchCode = getFactorByCode(65).Factorc;
        this.model.DivisionCode = getFactorByCode(66).Factorc;

        let response = undefined;
        if (
          !this.model.CompanyCode ||
          !this.model.BranchCode ||
          !this.model.DivisionCode
        ) {
          response = await DefaultCompanyBranchDivisionService.getDefault();

          if (response.data.value.length > 0) {
            this.model.CompanyCode = response.data.value[0].CompanyCode;
            this.model.BranchCode = response.data.value[0].BranchCode;
            this.model.DivisionCode = response.data.value[0].DivisionCode;
          }
        }

        this.getSalesUMs(this.model.BranchCode);

        await CompanyService.getByCompanyCode(this.model.CompanyCode).then(
          (res) => {
            this.model.CurrencyCode = res.data.value[0].CurrencyCode;
            this.model.CompanyCurrency = res.data.value[0].CurrencyCode;

            this.setFooterItems([]);
          }
        );

        let result = await CompanyCurrencyService.getByCurrencyCode(
          this.model.CurrencyCode
        );
        this.model.ExchangeRate = result.data.value[0].BuyRate;

        let factor549DefaultRequiredBy = getFactorByCode(549);

        if (factor549DefaultRequiredBy.Factorc == "Y") {
          let factor550RequiredByLeadDays = getFactorByCode(550);
          let requiredByLeadDays = parseInt(
            factor550RequiredByLeadDays.Factorc
          );
          let requiredByDate = new Date();
          requiredByDate.setDate(requiredByDate.getDate() + requiredByLeadDays);

          this.model.RequiredByDate = requiredByDate;

          let factor616DateForPriceGroupPriceSelection = getFactorByCode(616);
          if (factor616DateForPriceGroupPriceSelection.Factorc != "Date In") {
            this.model.FilterDate = this.model.RequiredByDate.toYYYYMMDD();
          } else {
            this.model.FilterDate = this.model.DateIn.toYYYYMMDD();
          }

          let factor565ShipDateSameAsRequiredByDate = getFactorByCode(565);

          if (factor565ShipDateSameAsRequiredByDate.Factorc == "Y") {
            this.model.ShipDate = this.model.RequiredByDate;
          } else {
            this.model.ShipDate = new Date();
          }
        }

        let factor87DefaultSalesOrderTypeCode = getFactorByCode(87);
        this.model.SalesOrderTypeCode =
          factor87DefaultSalesOrderTypeCode.Factorc;

        await this.setOrderComments(this.model.SalesOrderTypeCode);

        this.loaded = true;
        this.showLoading(false);
      } else {
        await this.$store.dispatch("screenFactors/getFactors", [505]);
        // if (this.baseView.mode == "review")
        //   this.$store.dispatch("dataContext/setDataViewType", "review");
        // else
        //   this.$store.dispatch("dataContext/setDataViewType", "product-entry");

        await SalesOrderService.getByCode(this.baseView.id)
          .then((res) => {
            if (res.data.value[0].Customer.StopCredit == "Y")
              res.data.value[0].CustomStatus = "Credit Hold";
            else res.data.value[0].CustomStatus = undefined;

            res.data.value[0].LineItemCode = undefined;

            res.data.value[0].SalesOrder = res.data.value[0].Code;
            this.model = res.data.value[0];
            this.model.CustomerDeliveryAddressLineNo =
              this.model.CustomerDeliveryAddressLineNo.split(" ")[0];

            this.model.CustomerName = res.data.value[0].Customer.Name;
            this.model.SalesRepresentativeFullName =
              res.data.value[0].SalesRepresentative.FirstName +
              " " +
              res.data.value[0].SalesRepresentative.Surname;
          })
          .catch((err) => {
            if (err) this.showLoading(false);
          });

        await this.setOrderComments(this.model.SalesOrderTypeCode);

        await SalesOrderNoteService.getNotesBySOCode(this.baseView.id)
          .then((res) => {
            this.model.Notes = res.data.value;
          })
          .catch((err) => {
            if (err) this.showLoading(false);
          });

        let record = await SalesOrderV3Service.getSalesOrderDetailsByCode(
          this.baseView.id
        );
        if (record && record.data.value.length > 0) {
          var data = record.data.value;
          await data.forEach(async (element, index) => {
            // this.model.Status = element.Status;
            // element.Description1 = element.ItemDescription;
            element.ItemDescription = element.Description1;
            element.Code = element.ItemCode;
            element.ProductCode = element.ItemCode;
            element.ProductDescription = element.Description1;
            element.ID = index + 1;
            element.validCode = element.ItemCode;
            // this.productEntryLocalItems.push({ ...element });

            this.productEntryLocalItems.insert(element);
          });
        }

        this.setFooterItems(this.productEntryLocalItems._array);
        // await this.setProductDataSourceItems();

        this.loaded = true;
        this.showLoading(false);

        if (this.$refs["dx-data-grid-comp"]) {
          var dataGrid = this.$refs["dx-data-grid-comp"].instance;
          dataGrid.refresh(true);
        }
      }
      // this.loaded = true;
    },
    async editSOCallBack() {
      this.setDeliveryAddressDataSourceItems(
        this.model.CustomerCode,
        this.model.CustomerDeliveryAddressLineNo
      );
      await CompanyService.getByCompanyCode(this.model.CompanyCode).then(
        (res) => {
          this.model.CurrencyCode = res.data.value[0].CurrencyCode;
          this.model.CompanyCurrency = res.data.value[0].CurrencyCode;
        }
      );
      await this.setProductDataSourceItems();
    },

    async getSalesUMs(branchCode) {
      await SalesOrderV3Service.getSaleItemCompanyBranchProduct(
        branchCode
      ).then((res) => {
        this.salesUMsLocalData = res.data.value;
      });
    },

    async setDefaultSalesRep() {
      var featureItems = FeatureStorage.getItems();
      if (featureItems[0].ApplicationUserTypeCode == "Sales") {
        await SalesRepresentativeService.getUserDefaultSalesRepresentative().then(
          (res) => {
            this.model.SalesRepresentativeCode =
              res.data.value[0].SalesRepresentativeCode;
          }
        );
      } else {
        if (getFactorByCode(95).Factorc) {
          this.model.SalesRepresentativeCode = getFactorByCode(95).Factorc;
        } else {
          await CustomerService.getByCode(this.baseView.id)
            .then((res) => {
              this.model.SalesRepresentativeCode =
                res.data.value[0].SalesRepresentativeCode;
            })
            .catch((err) => {
              if (err) {
                this.model.SalesRepresentativeCode = undefined;
              }
            });
        }
      }
    },
    // End - On initialized Functions

    // Save Sales Order
    async saveTransaction(isValid, brokenRules) {
      if (!isValid) this.displayValidationSummary(brokenRules);
      else {
        this.saveSalesOrder(this.model);
      }
    },
    async saveSalesOrder(e) {
      if (this.productEntryLocalItems.length == 0) {
        // this.addValidations(
        //   "Sales Order has no detail. Please add one or more lines before attempting to save the transaction again."
        // );

        this.displayValidationErrors([
          "Sales Order has no detail. Please add one or more lines before attempting to save the transaction again.",
        ]);
        return;
      }

      if (e.NextStatus == "X") {
        let confirmLeaving = await this.$confirm(
          "Do you really wish to cancel sales order?",
          "Cancel sales order"
        );

        if (confirmLeaving) {
          this.$logger.trackEventButtonClick("Cancel Sales Order");
          this.cancelSalesOrder();
        }
      } else {
        let payload = this.getSavePayload();

        this.showLoading(true);
        await SalesOrderV3Service.saveSalesOrder(payload, payload.Code)
          .then((res) => {
            this.showLoading(false);

            if (this.baseView.mode == "create") {
              this.model.Code = res.data.Code;
            }

            this.$notify(
              `Sales Order ${this.model.Code} Successfully Saved`,
              "success"
            );

            this.setIgnoreRouteChangeConfirmation();
            this.$router.push({
              path: `/sales-order`,
            });
          })
          .catch((error) => {
            this.showLoading(false);

            this.displayServerError(error, "Save Sales Order Failed");
          });
      }
    },
    async cancelSalesOrder() {
      this.setLoading = true;
      var payload = {
        Code: this.baseView.id,
      };
      await SalesOrderService.cancelSalesOrder(payload)
        // eslint-disable-next-line no-unused-vars
        .then((result) => {
          this.setLoading = false;
          // this.$logger.debug("result ", result);
          this.setIgnoreRouteChangeConfirmation();
          this.$router.push({
            path: `/sales-order`,
          });
        })
        .catch((error) => {
          this.setLoading = false;

          this.setLoading = false;
          this.displayServerError(error, "Cancel sales order Failed");
        });
    },

    getSavePayload() {
      var ExTaxTotal = 0;
      var TaxTotal = 0;
      var Total = 0;
      this.productEntryLocalItems._array.forEach((element) => {
        if (element.ItemCode && element.SalesUMQty) {
          ExTaxTotal = ExTaxTotal + element.TaxableFXLineTotal;
          TaxTotal = TaxTotal + element.TaxFXLineTotal;
          Total = Total + element.FXLineTotal;
        }
      });
      let payload = {
        BranchCode: this.model.BranchCode,
        Code: this.baseView.id ? parseInt(this.baseView.id) : 0,
        CompanyCode: this.model.CompanyCode,
        ConsignmentNo: this.model.ConsignmentNo,
        CurrencyCode: this.model.CurrencyCode,
        CustomerCode: this.model.CustomerCode,
        CustomerDeliveryAddressLineNo:
          this.model.CustomerDeliveryAddressLineNo.toString(),
        DateIn: new Date(this.model.DateIn).toSaveDate(),
        DeliveryAddressCompanyName: this.model.DeliveryAddressCompanyName,
        DeliveryAddressCountry: this.model.DeliveryAddressCountry,
        DeliveryAddressPostcode: this.model.DeliveryAddressPostcode,
        DeliveryAddressState: this.model.DeliveryAddressState,
        DeliveryAddressStreetLine1: this.model.DeliveryAddressStreetLine1,
        DeliveryAddressStreetLine2: this.model.DeliveryAddressStreetLine2,
        DeliveryAddressSuburb: this.model.DeliveryAddressSuburb,
        Status: this.model.NextStatus,
        DivisionCode: this.model.DivisionCode,
        ExchangeRate: this.model.ExchangeRate,
        ExTaxTotal: parseFloat(ExTaxTotal.toFixed(2)),
        ItemCount: this.getSalesOrderDetailPayload().length,
        OrderNo: "",
        RequiredByDate: new Date(this.model.RequiredByDate).toSaveDate(),
        SalesOrderTypeCode: this.model.SalesOrderTypeCode,
        SalesRepresentativeCode: this.model.SalesRepresentativeCode,
        ShipDate: new Date(this.model.ShipDate).toSaveDate(),
        // Status: "A",
        TaxTotal: parseFloat(TaxTotal.toFixed(2)),
        Total: parseFloat(Total.toFixed(2)),
        UserComment1: this.model.UserComment1,
        UserComment2: this.model.UserComment2,
        UserComment3: this.model.UserComment3,
        UserComment4: this.model.UserComment4,
        UserComment5: this.model.UserComment5,
        UserComment6: this.model.UserComment6,
        UserComment7: this.model.UserComment7,
        UserComment8: this.model.UserComment8,
        UserComment9: this.model.UserComment9,
        UserComment10: this.model.UserComment10,
        UserComment11: this.model.UserComment11,
        UserComment12: this.model.UserComment12,
        UserComment13: this.model.UserComment13,
        UserComment14: this.model.UserComment14,
        UserComment15: this.model.UserComment15,
        UserComment16: this.model.UserComment16,
        UserComment17: this.model.UserComment17,
        UserComment18: this.model.UserComment18,
        UserComment19: this.model.UserComment19,
        UserComment20: this.model.UserComment20,

        SalesOrderDetails: this.getSalesOrderDetailPayload(),
        SalesOrderNotes: [],
      };

      if (this.model.Notes && this.model.Notes.length > 0) {
        let notes = this.model.Notes.map((note) => {
          let n = {
            LineNo: note.LineNo ? note.LineNo : 0,
            Note: note.Note,
          };
          return n;
        });
        payload.SalesOrderNotes = notes;
      }

      // delete payload.Status;
      // if (this.baseView.mode == "create") delete payload.Code;

      if (this.baseView.mode != "create") {
        payload.DateChanged = this.model.DateChanged;
      }
      return payload;
    },

    getSalesOrderDetailPayload() {
      let details = [];

      this.productEntryLocalItems._array.forEach((data) => {
        let detailObj = {
          SalesOrderCode: data.SalesOrderCode ? data.SalesOrderCode : 0,
          LineNo: data.LineNo ? data.LineNo : 0,
          ItemCode: data.ItemCode,
          SalesUM: data.SalesUM,
          SalesUMQty: data.SalesUMQty,
          DiscPcnt: data.DiscPcnt,
          SalesUMPrice: data.SalesUMPrice,
          Comment: data.Comment,
          IsCommentVisible: data.IsCommentVisible,
          RecordId: "00000000-0000-0000-0000-000000000000",
        };

        if (data.ItemCode && data.SalesUMQty) details.push(detailObj);
      });

      return details;
    },

    // Footer

    async setFooterItems(gridItems) {
      // this.showFooter = false;
      this.getFooterItems
        .filter((x) => (x.hasOwnProperty("visible") ? x.visible : true))
        .forEach((x) => {
          x.value = this.updateValue(x.dataField, gridItems);
          if (x.customCalc) x.value = x.customCalc(this.model, gridItems);
        });
      this.footerItems = this.getFooterItems;
      this.showFooter = true;
    },
    updateValue(dataField, items) {
      let result = 0;
      if (items.length > 0)
        items.forEach((x) => {
          if (x.CheckInclude || this.baseView.mode == "review")
            result += parseFloat(x[dataField]).roundNumber(4);
          else if (x.CheckInclude == undefined)
            result += parseFloat(x[dataField]).roundNumber(4);
        });

      return result;
    },
  },
  watch: {
    async getValidationSummaryVisible(val) {
      if (!val && this.validationLineData == "Customer") {
        if (this.gridExpand) await this.expandGrid();
        this.validationLineData = undefined;
        var headerToolBarForm =
          this.$refs["gc-header-form-component"].$refs["gc-form-header-toolbar"]
            .$refs["toolbar-form"].$refs["gc-form-comp"].instance;
        if (headerToolBarForm) {
          headerToolBarForm.getEditor("CustomerCode").focus();
          var cusDropdown = headerToolBarForm
            .getEditor("CustomerCode")
            .instance();
          cusDropdown.open();
        }
      } else if (!val && this.validationLineData == "ProductCode") {
        this.validationLineData = undefined;
        this.validationDataField = undefined;

        var dxform = this.$refs["dx-form-add-new-comp"].instance;
        dxform.repaint();

        // var element = dxform.getEditor("ProductCode");
        // element.blur();

        // // setTimeout(() => {
        // element.focus();
        // // }, 100);
      }
    },
  },
};
</script>

<style lang="scss">
.sales-order-v2 {
  .dx-datagrid .dx-datagrid-content .dx-datagrid-table .dx-row > td {
    vertical-align: middle !important;
  }
}

.sales-order-v5 {
  // background-color: #a6a6a65c;
  .gc-product-entry-form {
    padding: 12px !important;
    margin: 0 !important;

    .dx-scrollable-container {
      margin: 0;
      padding: 0;
      .dx-scrollable-content {
        .dx-layout-manager {
          padding: 0 !important;
        }
      }
    }

    .footer {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
    }
  }

  .gc-header-form {
    // padding: 10px 10px 0 10px;

    div > .view-toolbar {
      // border-radius: 5px;
    }

    > .view-card {
      // border-radius: 5px;
    }
  }

  .gc-data-grid-so-v5 {
    // padding: 10px;

    // padding: 0 10px 10px 10px;
    // background-color: #a6a6a65c;

    .dx-datagrid-pager .dx-pages .dx-page.dx-selection {
      display: none;
    }

    width: 100%;
    display: inline-flex;
    .left {
      // padding-right: 10px;
      // width: 20%;
      .gc-product-entry-form {
        // border-radius: 5px;
      }
    }
    // .right {
    //   width: 80%;
    // }

    .gc-product-entry-form {
      .dx-button.dx-state-disabled .dx-button-text {
        color: rgba($color: #ffffff, $alpha: 0.35);
      }
    }
  }
}
</style>
